'use client'
import Image from 'next/image'
import handsIcon from './assets/hands.svg'
import desktopWave from './assets/wave-desktop.svg'
import mobileWave from './assets/wave-mobile.svg'
import styles from './CorporateWave.module.scss'
import { useDeviceMedia } from '@/tools/ui'

export const CorporateWave = () => {
  const { isMobile } = useDeviceMedia()

  const waveSource = isMobile ? mobileWave : desktopWave
  return (
    <section className={styles.topContent}>
      <Image alt={''} className={styles.wave} height={80} src={waveSource} width={110} />
      <Image alt={''} className={styles.icon} height={80} src={handsIcon} width={110} />
    </section>
  )
}
